<template>
  <div :class="{ shadow: showShadows }" class="dc-panel rounded-sm bg-white">
    <div :class="{ 'pb-4': title || (collapsable && isCollapsed) }" class="flex w-full items-center px-4 pt-4">
      <button
        v-if="collapsable && title"
        type="button"
        class="flex-grow text-left text-lg text-gray-700"
        @click="isCollapsed = !isCollapsed"
      >
        {{ title }}
      </button>

      <h1 v-else-if="!collapsable && title" class="flex-shrink-0 text-lg text-gray-700">
        {{ title }}
      </h1>

      <slot name="header" />

      <div v-if="$slots && $slots.title" class="ml-auto w-1/2">
        <slot name="title" />
      </div>

      <Button
        v-if="collapsable"
        class="ml-2 flex items-center justify-center"
        theme="empty"
        @click="isCollapsed = !isCollapsed"
      >
        <Icon :class="{ 'is-collapsed': isCollapsed }" name="chevron-up" class="collapse-icon text-gray-700" />
      </Button>
    </div>
    <div v-show="collapsable ? !isCollapsed : true" class="overflow-x-auto px-4 pb-4" style="overflow-y: hidden">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    collapsable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFlat: false,
      isCollapsed: this.collapsed,
    }
  },
  computed: {
    showShadows() {
      return !this.isFlat && !!this.flat
    },
  },
}
</script>

<style lang="scss" scoped>
.collapse-icon {
  transition-property: transform;
  transition-duration: 200ms;

  &.is-collapsed {
    transform: rotate(180deg);
  }
}
</style>
